function getCurrentRelease(): string | undefined {
  return process.env.REACT_APP_RELEASE
}

export default getCurrentRelease
